import { Box } from '@squareup/dex-ui-shared-base';
import React, { FC, PropsWithChildren } from 'react';

import styles from './api-explorer-depth-wrapper.module.css';

const MAX_DEPTH = 5;

interface Props {
  id?: string;
  depth: number;
  onClick?: () => void;
}

const ApiExplorerDepthWrapper: FC<PropsWithChildren<Props>> = ({
  id,
  depth,
  children,
  onClick,
}) => {
  return (
    <Box
      id={id}
      className={styles['depth-wrapper']}
      data-depth={depth % MAX_DEPTH}
      padding={{ left: '3x' }}
      margin={{ top: '2x' }}
      border={{ line: { left: 'standard' } }}
    >
      <Box
        testId={'api-explorer-collapse-click-target'}
        className={styles['click-target']}
        onClick={onClick}
      />
      {children}
    </Box>
  );
};

export { ApiExplorerDepthWrapper };
